<template>
     <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="product"
            :fields="fields"
            :per-page="search.perPage"
            :busy="addProduct.isLoadTable"
            class="scroll-bar-pop text-center"
            empty-text="คุณยังไม่มีรายการสินค้า กรุณาเพิ่มรายการของคุณ"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
            <template slot="rate" slot-scope="data">{{data.item.rate | numFormat('0,0.00')}}</template>
            <template slot="fee" slot-scope="data">{{data.item.fee | numFormat('0,0.00')}}</template>
            <template slot="price" slot-scope="data">{{ (Number(data.item.fee) + Number(data.item.rate) ) | numFormat('0,0.00')}}</template>
            <template slot="manage" slot-scope="data">
                <b-button
                    size="sm" 
                    variant="info" 
                    class="px-3" 
                    @click="openModalEditService( data.item.id )"
                >
                    <i class="fas fa-circle-notch fa-spin" v-if="addProduct.serviceId == data.item.id"></i>
                    <i class="fas fa-pen" v-else></i> แก้ไข
                </b-button>
                <b-button
                    size="sm" 
                    variant="danger" 
                    class="px-3" 
                    @click="openModalDeleteService( data.item )"
                >
                    <i class="fas fa-trash-alt"></i> ลบ
                </b-button>
            </template>
        </b-table>
        <div class="mt-3">
            <b-pagination 
                :total-rows="search.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page" 
                @input="changePage"
                align="right">
            </b-pagination>
        </div>   
        <ModalConfirm
            ref="confirmDelete"
            :confirm="confirm"
            @confirmModal="checkConfirmModal()"
        />    
    </div>
</template>

<script>
import ModalConfirm from '@/components/Modals//ModalConfirm'
import { getServiceDetail , deleteService } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    props:{
        search: Object,
        product: Array,
        addProduct: Object,
    },
    components:{
        ModalConfirm
    },
    data(){
        return{
            confirm: {
                show: false,
                icon: "",
                emphasize: "",
                text: "",
                isLoad: false
            }
        }
    },
    methods:{
        getOverAllIndex(index){
            return ( this.search.page * 25 ) - 25 + index + 1
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.$emit('getApiProductDetails');
        },
        openModalEditService( id ){
            this.addProduct.serviceId = id
            getServiceDetail( this.addProduct ).then( res => {
                this.addProduct.name = res.name;
                this.addProduct.categoryId = ( res.product_category_id ) ? res.product_category_id : 0 ;
                this.addProduct.categoryIdDefault = this.addProduct.categoryId;
                this.addProduct.image.preview = res.image
                this.addProduct.rate = res.rate
                this.addProduct.fee = res.fee
                this.addProduct.price = Number(res.fee) + Number(res.rate)
                this.addProduct.show = true
            }).catch( error => {
                showErrorModal(error)
            });
        },
        openModalDeleteService( item ){
            this.confirm.show = true
            this.confirm.icon = '<i class="fas fa-trash-alt text-red fa-2x"></i>'
            this.confirm.emphasize = `ลบ ${item.name}`
            this.confirm.text = 'สินค้านี้จะถูกลบออกจากระบบ คุณต้องการที่จะลบหรือไม่'
            this.addProduct.serviceId = item.id
        },
        checkConfirmModal(){
            this.confirm.isLoad = true;
            deleteService(this.addProduct).then( () => {
                this.addProduct.serviceId = null
                this.$refs.confirmDelete.closeModalConfirm();
                showSuccessModal('ลบข้อมูลสำเร็จ')
                this.$emit('getApiProductDetails');
            }).catch( error => {
                showErrorModal(error)
                this.confirm.isLoad = false
            });
        }
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "name", label: "ชื่อสินค้า", sortable: true },
                { key: "category_name", label: "ชื่อหมวดหมู่", sortable: true },
                { key: "fee", label: "กำไร", sortable: true },
                { key: "rate", label: "ต้นทุน", sortable: true },
                { key: "price", label: "ราคาขาย", sortable: true },
                { key: "created_at", label: "วันที่สร้าง", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>